import { request as makeRequestWithWorker } from "./api-request.worker";
import { buildQueryString } from "./api";
import {SRApi as SRBaseAPI} from "./api";


class SRApi extends SRBaseAPI {
    async request(method, path, { params, query, headers }) {
        const responseJson = await makeRequestWithWorker(method, this.url(path) + buildQueryString(query), {
            params, query, headers: {
                ...this.headers(),
                ...headers,
            }
        });

        return responseJson;
    }
}

export default new SRApi();
